
import CryptoJS from 'crypto-js'

export function encryptJSON(json: unknown, secretKey: string): string {
  const jsonString = JSON.stringify(json)
  return CryptoJS.AES.encrypt(jsonString, secretKey).toString()
}

export function decryptJSON<T = unknown>(encrypted: string, secretKey: string): T {
  const bytes = CryptoJS.AES.decrypt(encrypted, secretKey)
  const jsonString = bytes.toString(CryptoJS.enc.Utf8)
  return JSON.parse(jsonString) as T
}
